<script lang="ts">
    import type {Document, RecordSearchParams} from 'typings/portaro.be.types';
    import type {TabButton} from 'shared/ui-widgets/tabset/types';
    import {Kind, SearchType} from 'shared/constants/portaro.constants';
    import {RecordGridService} from 'src/features/record-grid/services/record-grid.service';
    import {getInjector} from 'core/svelte-context/context';
    import {onMount} from 'svelte';
    import {createSutorReportsOptimisationContext} from './sutor-reports-optimisation-context';
    import {
        SearchManagerBuilderFactoryService
    } from 'src/features/search/search-manager/search-manager-factory.service';
    import {SutorReportsOptimisationService} from './sutor-reports-optimisation.service';
    import {SUTOR_REPORTS_OPTIMISATION_SETTINGS} from 'src/features/sutor/sutor-constants';
    import ErpTabbedSubpagesContainer
        from 'src/features/erp/components/erp-tabbed-subpages/ErpTabbedSubpagesContainer.svelte';
    import ReportOptimisationGrid from './grid/ReportOptimisationGrid.svelte';
    import ReportOptimisationUsers from './users/ReportOptimisationUsers.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import ReportOptimisationOverviews from './overviews/ReportOptimisationOverviews.svelte';

    export let record: Document;
    export let reportedProject: boolean;

    const recordGridService = getInjector().getByClass(RecordGridService);
    const service = getInjector().getByClass(SutorReportsOptimisationService);
    const searchManagerBuilderFactoryService = getInjector().getByClass(SearchManagerBuilderFactoryService);
    const context = createSutorReportsOptimisationContext(record, service);

    let loading = true;

    const tabs = {};
    const tabButtons: TabButton[] = [
        {
            id: 'tab-grid',
            label: 'Náklady k optimalizaci',
            icon: 'list',
            tabPageWithoutPadding: true,
            tabPageContainerClass: 'record-grid-tab-page'
        },
        {
            id: 'tab-overviews',
            label: 'Přehledy',
            icon: 'info',
            tabPageWithoutPadding: true
        }
    ];

    if (reportedProject) {
        tabButtons.push({
            id: 'tab-users',
            label: 'Dostupní uživatelé',
            icon: 'users',
            tabPageWithoutPadding: true
        });
    }

    onMount(async () => {
        const optimisationFond = await recordGridService.getFond(SUTOR_REPORTS_OPTIMISATION_SETTINGS.fond);

        tabs['tab-overviews'] = {component: ReportOptimisationOverviews};

        tabs['tab-grid'] = {
            component: ReportOptimisationGrid,
            props: {
                fond: optimisationFond
            }
        };

        if (reportedProject) {
            tabs['tab-users'] = {component: ReportOptimisationUsers};
        }

        createSearchManagers();
        loading = false;
    });

    function createSearchManagers() {
        const optimisationTableSearchManagerBuilder = searchManagerBuilderFactoryService.createBuilder<RecordSearchParams, any>().withStaticParams(createOptimisationTableStaticParams());
        context.optimisationTableSearchContext = optimisationTableSearchManagerBuilder.createLocalSearch(true);
    }

    function createOptimisationTableStaticParams(): RecordSearchParams {
        return {
            recordRelatedRecord: context.projectRecord.id,
            kind: [Kind.KIND_RECORD],
            type: SearchType.TYPE_TABLE,
            rootFond: [{id: SUTOR_REPORTS_OPTIMISATION_SETTINGS.fond}],
            pageSize: 100
        };
    }
</script>

{#if loading}
    <KpLoadingBlock fillPage/>
{/if}

{#if !loading}
    <ErpTabbedSubpagesContainer {tabButtons}
                                let:activeTab
                                additionalClasses="reports-optimisation-tabbed-subpages"
                                withoutUrlManagement>

        <svelte:component this="{tabs[activeTab].component}" {...tabs[activeTab].props ?? {}}/>
    </ErpTabbedSubpagesContainer>
{/if}